import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function BenefitsSection() {
  // Function to handle navigation clicks with smooth scrolling
  const handleNavClick = sectionId => {
    // Prevent default anchor behavior
    event.preventDefault();
    // Get the target element to scroll to
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      // Scroll smoothly to the element
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      // Update URL without page reload
      history.pushState(null, null, `#${sectionId}`);
    }
  };
  return <section id="benefits" className="py-20 bg-white" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900" data-id="element-17">
            Why Businesses Choose Us
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-18">
            We understand the unique challenges of marketing your business
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-19">
          <div className="bg-gray-50 rounded-xl p-8 shadow-sm" data-id="element-20">
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-navy-100 text-navy-800 mb-6" data-id="element-21">
              <CheckCircleIcon className="h-6 w-6" data-id="element-22" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-23">
              Industry Expertise
            </h3>
            <p className="text-gray-600" data-id="element-24">
              We specialize in marketing for various businesses and understand
              what motivates your customers to book your services.
            </p>
          </div>
          <div className="bg-gray-50 rounded-xl p-8 shadow-sm" data-id="element-25">
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-navy-100 text-navy-800 mb-6" data-id="element-26">
              <CheckCircleIcon className="h-6 w-6" data-id="element-27" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-28">
              No Long-Term Contracts
            </h3>
            <p className="text-gray-600" data-id="element-29">
              We earn your business each month with results. No long-term
              commitments required - our results keep clients coming back.
            </p>
          </div>
          <div className="bg-gray-50 rounded-xl p-8 shadow-sm" data-id="element-30">
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-navy-100 text-navy-800 mb-6" data-id="element-31">
              <CheckCircleIcon className="h-6 w-6" data-id="element-32" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-33">
              Transparent Reporting
            </h3>
            <p className="text-gray-600" data-id="element-34">
              Get clear, easy-to-understand reports that show exactly how your
              campaigns are performing and the leads they generate.
            </p>
          </div>
          <div className="bg-gray-50 rounded-xl p-8 shadow-sm" data-id="element-35">
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-navy-100 text-navy-800 mb-6" data-id="element-36">
              <CheckCircleIcon className="h-6 w-6" data-id="element-37" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-38">
              Done-For-You Service
            </h3>
            <p className="text-gray-600" data-id="element-39">
              We handle everything from ad creation to campaign management, so
              you can focus on serving your clients.
            </p>
          </div>
          <div className="bg-gray-50 rounded-xl p-8 shadow-sm" data-id="element-40">
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-navy-100 text-navy-800 mb-6" data-id="element-41">
              <CheckCircleIcon className="h-6 w-6" data-id="element-42" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-43">
              Lead Qualification
            </h3>
            <p className="text-gray-600" data-id="element-44">
              Our ads pre-qualify leads, so you spend time talking to serious
              prospects who are ready to book your services.
            </p>
          </div>
          <div className="bg-gray-50 rounded-xl p-8 shadow-sm" data-id="element-45">
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-navy-100 text-navy-800 mb-6" data-id="element-46">
              <CheckCircleIcon className="h-6 w-6" data-id="element-47" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-48">
              Proven Results
            </h3>
            <p className="text-gray-600" data-id="element-49">
              Our clients typically see a 3-5x return on ad spend, with an
              average of 20+ qualified leads per month.
            </p>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-50">
          <a href="#contact" className="inline-block px-8 py-4 rounded-md bg-navy-800 text-white font-bold text-lg hover:bg-navy-700 transition-all duration-300 hover:translate-y-1" onClick={e => {
          e.preventDefault();
          handleNavClick('contact');
        }} data-id="element-51">
            Schedule Your Free Strategy Call
          </a>
        </div>
      </div>
    </section>;
}